import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@parashift/shared/services';

@Component({
  selector: 'app-session-callback',
  templateUrl: './callback.component.html'
})
export class SessionCallbackComponent {
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() {
    // The session was established during app init; navigate to the destination id-api chose.
    this.authService.navigateAfterLogin(this.router);
  }
}
